import { store } from "../app/store";
import { setLoading } from "../core/loading/loadingSlice";

let activeRequests = 0;

export const loadingRequestInterceptor = (config: any) => {
  // Skip global loader if the request has skipGlobalLoader flag
  if (config.skipGlobalLoader) {
    return config;
  }

  activeRequests++;
  if (activeRequests === 1) {
    store.dispatch(setLoading(true));
  }
  return config;
};

export const loadingResponseInterceptor = (response: any) => {
  // Skip global loader if the request had skipGlobalLoader flag
  if (response.config.skipGlobalLoader) {
    return response;
  }

  activeRequests--;
  if (activeRequests === 0) {
    store.dispatch(setLoading(false));
  }
  return response;
};

export const loadingErrorInterceptor = (error: any) => {
  // Skip global loader if the request had skipGlobalLoader flag
  if (error.config?.skipGlobalLoader) {
    return Promise.reject(error);
  }

  activeRequests--;
  if (activeRequests === 0) {
    store.dispatch(setLoading(false));
  }
  return Promise.reject(error);
};
